'use client';

import { Info } from 'lucide-react';
import IconAdaptive from '@/components/IconAdaptive';

type DashboardPersonalNoteUnitProps = {
    messages: string[];
};

export default function DashboardPersonalNoteUnit({ messages }: DashboardPersonalNoteUnitProps) {
    return (
        <div className="flex items-center gap-x-3 w-full rounded-xl bg-color-button-blue-icon/10 px-4 py-3">
            <div className="flex items-center justify-center rounded-full bg-color-button-blue-icon p-1.5 flex-none">
                <IconAdaptive
                    Icon={Info}
                    baseSize={16}
                    breakpoints={{ md: 18 }}
                    strokeWidth={2.25}
                    className="text-color-white-base"
                />
            </div>
            <div className="flex flex-col gap-y-1 min-w-0 font-notojp text-xs md:text-sm text-color-base leading-relaxed">
                {messages.map((message) => (
                    <p key={message}>{message}</p>
                ))}
            </div>
        </div>
    );
}
